"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMediaQuery = void 0;
const react_1 = require("react");
const MediaQueryContext_1 = require("./MediaQueryContext");
const useMediaQuery = ({ minWidth = 0, maxWidth = 99999 }) => {
    const mediaQueryContext = (0, react_1.useContext)(MediaQueryContext_1.MediaQueryContext);
    if (mediaQueryContext === undefined) {
        throw Error("MediaQuery Provider not found");
    }
    const { width: windowWidth } = mediaQueryContext;
    return windowWidth >= minWidth && windowWidth <= maxWidth;
};
exports.useMediaQuery = useMediaQuery;
//# sourceMappingURL=useMediaQuery.js.map